import { postRequest } from "./QuoteApiService";

export const getCustomers = (requestBody)=> {
    return postRequest('GetAccounts', requestBody);
};

export const countCustomers = (requestBody)=> {
    return postRequest('CountAccounts', requestBody);
};